import { type FC, type ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';

import { updateValidation } from '@editor2/services/elementValidationsActionsService';
import {
	type ResponseBoard,
	type SAQuestion,
	type SAQuestionValidation
} from '@editor2/types/pageElements';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import { type FormControlElement } from '@editor2/types/formControl';

interface Props {
	element: SAQuestion | ResponseBoard;
	validation: SAQuestionValidation;
	validationIndex: number;
	courseId: number;
}

export const Threshold: FC<Props> = (props) => {
	const { element, validation, validationIndex, courseId } = props;

	const debouncedDispatch = useDebouncedDispatch();
	const handleChange = (e: ChangeEvent<FormControlElement>) =>
		debouncedDispatch(
			updateValidation(
				element,
				{
					...validation,
					parameters: {
						...validation.parameters,
						...(validation.name === 'max-word-count'
							? { maximum: +e.target.value }
							: { minimum: +e.target.value })
					}
				},
				validationIndex,
				courseId
			)
		);

	const thresholdValue =
		validation.name === 'max-word-count'
			? validation.parameters?.maximum
			: validation.parameters?.minimum;
	return (
		<>
			{!validation.enabled && <div>[N/A]</div>}
			{validation.enabled && validation.element_override && (
				<Form.Control
					type="number"
					step={1}
					defaultValue={thresholdValue || 0}
					onChange={handleChange}
				/>
			)}
			{validation.enabled && !validation.element_override && <span>{thresholdValue || 0}</span>}
		</>
	);
};
